// eslint-disable-next-line import/prefer-default-export
export const lastPaymentMethodSelector = ({ purchases }) =>
  purchases?.lastPaymentMethod;
